import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useCompanyIdFromPath = () => {
  const { pathname } = useLocation();

  const companyId = useMemo(() => {
    // exclude create band path as it does not have an id
    const paths = pathname.split("/");
    if (paths.length > 2 && paths[1] === "company") {
      return paths[2];
    }
    return null;
  }, [pathname]);

  return companyId;
};
